import * as JSZip from 'jszip';

export class ConfigurationTerrain{

    public static readonly DEFAULT_TERRAIN_NAME = "Default Terrain";

    public static readonly DEFAULT_GTOPO30 = "GTOPO30 Terrain";
  
    active: boolean = true;
    id: number;
    name: string = "";
    path: string;
    position: number;
    projectId: number;
    terrainTypeId: number;
    terrainFile: File;
    projectName?: String;
  
    isselected : boolean = false;

    requestNumber: number;
    terrainSize: number;
    chunkSize: number;
    numberOfRequests: number;
  
    static map(data: any): ConfigurationTerrain{
      var model = new ConfigurationTerrain();
      model.active = data?.active;
      model.projectId = data?.projectId;
      model.id = data?.id;
      model.path = data?.path;
      model.terrainTypeId = data?.terrainTypeId;
      model.position = data?.position;
      model.name = data?.name;
      model.terrainFile = data?.terrainFile
      return model;
    }
  
    static mapToService(data: ConfigurationTerrain): any {
      var model: any = new Object;
      model.active = data?.active;
      model.projectId = data?.projectId;
      model.id = data?.id;
      model.path = data?.path;
      model.terrainTypeId = data?.terrainTypeId;
      model.position = data?.position;
      model.name = data?.name;
      model.terrainFile = data?.terrainFile
      return model;
    }
  
    static mapToFormData(terrain: ConfigurationTerrain): FormData{
      const formData: FormData = new FormData();
      formData.append('active', JSON.stringify(terrain.active));
      terrain.id != null? formData.append('id', terrain.id.toString()): false;
      formData.append('name', terrain.name);
      terrain.path != null? formData.append('path', terrain.path): false;
      formData.append('position', terrain.position.toString());
      formData.append('projectId', terrain.projectId.toString());
      formData.append('terrainTypeId', terrain.terrainTypeId.toString());
      terrain.numberOfRequests? formData.append('numberOfRequests', terrain.numberOfRequests.toString()): false;
      terrain.terrainSize? formData.append('terrainSize', terrain.terrainSize.toString()): false;
      return formData;
    }
}

export class TerrainTypeModel{
    id: number;
    type: string;
}

export class TerrainFileValidator{


    public static readonly DEFAULT_RESOLUTION: number = 30;

    private static readonly GTOPO_EXTENSION: string = "dem";
    private static readonly DTED0_EXTENSION: string = "dt0";
    private static readonly DTED1_EXTENSION: string = "dt1";
    private static readonly DTED2_EXTENSION: string = "dt2";
    private static readonly SRTM_EXTENSION: string = "hgt";
    private static readonly ASTER_EXTENSION: string = "tif";
    private static readonly ASTER_STARTS_WITH: string = "astgtm2";
    private static readonly GEOTIFF_EXTENSION: string = "tif";
    private static readonly ASCII_EXTENSION: string = "asc";
    private static readonly ARCGRID_EXTENSION: string = "adf";
    private static readonly ARCGRID_RESOLUTION_FILE_EXTENSION: string = "xml";
    private static readonly ARCGRID_RESOLUTION_FILE_STARTS_WITH: string = "metadata";


    static async getTerrainResolutionFile(file: File, terrainType: String): Promise<FormData>{
        if (file == null || terrainType == null || terrainType == ""){
            return null;
        }
        switch (terrainType.toUpperCase()){
            case "GTOPO30":
                return await TerrainFileValidator.terrainResolutionFile(file, TerrainFileValidator.GTOPO_EXTENSION);
            case "DTED0":
                return await TerrainFileValidator.terrainResolutionFile(file, TerrainFileValidator.DTED0_EXTENSION);
            case "DTED1":
                return await TerrainFileValidator.terrainResolutionFile(file, TerrainFileValidator.DTED1_EXTENSION);
            case "DTED2":
                return await TerrainFileValidator.terrainResolutionFile(file, TerrainFileValidator.DTED2_EXTENSION);
            case "SRTM":
                return await TerrainFileValidator.terrainResolutionFile(file, TerrainFileValidator.SRTM_EXTENSION);
            case "ASTER":
                return await TerrainFileValidator.terrainResolutionFile(file, TerrainFileValidator.ASTER_EXTENSION, TerrainFileValidator.ASTER_STARTS_WITH);
            case "GEOTIFF":
                return await TerrainFileValidator.terrainResolutionFile(file, TerrainFileValidator.GEOTIFF_EXTENSION);
            case "ASCII":
                return await TerrainFileValidator.terrainResolutionFile(file, TerrainFileValidator.ASCII_EXTENSION);
            case "ARCGRID":
                return await TerrainFileValidator.terrainResolutionFile(file, TerrainFileValidator.ARCGRID_RESOLUTION_FILE_EXTENSION, 
                                                                                TerrainFileValidator.ARCGRID_RESOLUTION_FILE_STARTS_WITH);
            default:
                return null
        }
    }

    static async validateTerrainFile(file: File, terrainType: String): Promise<boolean>{
        if (file == null || terrainType == null || terrainType == ""){
            return false;
        }
        switch (terrainType.toUpperCase()){
            case "GTOPO30":
                return await TerrainFileValidator.validateTerrain(file, TerrainFileValidator.GTOPO_EXTENSION);
            case "DTED0":
                return await TerrainFileValidator.validateTerrain(file, TerrainFileValidator.DTED0_EXTENSION);
            case "DTED1":
                return await TerrainFileValidator.validateTerrain(file, TerrainFileValidator.DTED1_EXTENSION);
            case "DTED2":
                return await TerrainFileValidator.validateTerrain(file, TerrainFileValidator.DTED2_EXTENSION);
            case "SRTM":
                return await TerrainFileValidator.validateTerrain(file, TerrainFileValidator.SRTM_EXTENSION);
            case "ASTER":
                return await TerrainFileValidator.validateTerrain(file, TerrainFileValidator.ASTER_EXTENSION, TerrainFileValidator.ASTER_STARTS_WITH);
            case "GEOTIFF":
                return await TerrainFileValidator.validateTerrain(file, TerrainFileValidator.GEOTIFF_EXTENSION);
            case "ASCII":
                return await TerrainFileValidator.validateTerrain(file, TerrainFileValidator.ASCII_EXTENSION);
            case "ARCGRID":
                return await TerrainFileValidator.validateTerrain(file, TerrainFileValidator.ARCGRID_EXTENSION);
            default:
                return false
        }
    }
    

    private static async validateTerrain(zipFile:File, extension: string, startsWith?: string): Promise<boolean>{
        let toReturn: boolean = false;
        await JSZip.loadAsync(zipFile).then(zip => {
            for(let [filename, file] of Object.entries(zip.files)) {
                const newFileName = filename.trim().toLowerCase();
                let accept = newFileName.endsWith(extension); 
                if (startsWith){
                    const filePathSplit: string[] = newFileName.split("/");
                    accept = accept && filePathSplit.pop().startsWith(startsWith);
                }
                if (accept){
                    toReturn = true;
                    break;
                }
            }
        }).catch(err => {
            return false
        })
        return toReturn;
    }

    private static async terrainResolutionFile(zipFile: File, extension: string, startsWith?: string): Promise<FormData>{
        let formData: FormData = null;
        await JSZip.loadAsync(zipFile).then(async zip => {
            for(let [filename, file] of Object.entries(zip.files)) {
                const newFileName = filename.trim().toLowerCase();
                let accept = newFileName.endsWith(extension); 
                if (startsWith){
                    const filePathSplit: string[] = newFileName.split("/");
                    accept = accept && filePathSplit.pop().startsWith(startsWith);
                }
                if (accept){
                    await zip.files[filename].async('blob').then(fileBlob => {
                        formData = new FormData();
                        formData.append("file", fileBlob, filename);
                    })
                    break;
                }
            }
        }).catch(err => {})

        return formData;
    }

    // Keep commented. Only needed if get ArcGrid resolution method returns to old method.

    // private static async ArcGridResolutionFile(zipFile: File): Promise<FormData>{ 
    //     let formData: FormData = null;
    //     let firstDirFound: string[] = [];
    //     const zipGenerator: JSZip = new JSZip();
    //     await JSZip.loadAsync(zipFile).then(async zip => {
    //         for(let [filename, file] of Object.entries(zip.files)) {
    //             if (filename.trim().toLowerCase().endsWith(TerrainFileValidator.ARCGRID_EXTENSION)){
    //                 // cleanup file path
    //                 const filePathSplit: string[] = filename.split("/");
    //                 if (firstDirFound.length == 0){
    //                     if (filePathSplit.length > 2){
    //                         for (let i = 0; i<filePathSplit.length-1;i++){
    //                             firstDirFound.push(filePathSplit[i]);
    //                         }
    //                     } else {
    //                         firstDirFound.push(filePathSplit[0]);
    //                     }
    //                 }
    //                 let skip: boolean = false;
    //                 if (filePathSplit.length > 2){
    //                     for (let i = 0; i<filePathSplit.length-1;i++){
    //                         skip = skip || (firstDirFound[i] != filePathSplit[i]);
    //                     }
    //                 } else {
    //                     skip = firstDirFound[0] != filePathSplit[0];
    //                 } 
    //                 if (skip){
    //                     continue;
    //                 }
    //                 await zip.files[filename].async('blob').then(fileBlob => {
                        
    //                     filename = filePathSplit[0] + "/" + filePathSplit[filePathSplit.length - 1]; 
    //                     zipGenerator.file(filename, fileBlob);   
    //                 })
    //             }
    //         }
    //     }).catch(err => {})

    //     await zipGenerator.generateAsync({ type: 'blob' }).then(content => {
    //         formData = new FormData();
    //         formData.append("file", content, "ArcGridTerrainResolutionFile.zip");
    //       });

    //     return formData;
    // }

}